<template>
  <div class="gift">
    <div class="selectNumber w-full">
      <h5 class="m-0 text-NotoSansRegular selectGift_bg px-6 py-4 text-white relative arrow md:font-semibold text-sm">{{ giftData.name }}</h5>
      <h5 class="m-0 text-NotoSansRegular px-6 py-4 selectGift_color md:font-semibold text-sm">贈品：您已選了<span>{{ selectedGifts.length }}</span>件商品，還可再選
        <span>{{ remainGiftSelect }}</span>件商品
      </h5>
    </div>
    <div class="giftList flex" style="min-height: 247px">
      <div class="w-full md:px-3">
        <div class="container relative">
          <swiper :options="freeGiftOption" class="swiper h-full swiper_list">
            <swiper-slide v-for="(item, index) in giftData.gift_options" :key="index" :class="{ selected: selectedGifts.indexOf(item.id) !== -1 }" class="pt-3 pb-2 md:pt-8 md:pb-5 gift-item cursor-pointer h-auto">
              <label @click="selectItem(item)" :for="'radio-input-' + selectedGifts.indexOf(item.id)" class="w-full h-full input-helper input-helper--radio cursor-pointer flex md:block items-center">
                <div class="w-1/3 md:w-auto">
                  <div class="gift-inner bg-white" :class="{ 'opacity-25': item.out_of_stock }">
                    <div v-if="item.cover!==''" class="square-img" v-lazy:background-image="{ src: item.cover }"></div>
                    <div v-if="item.cover===''" class="square-img square-img-none"></div>
                  </div>
                </div>
                <div class="giftName text-NotoSansRegular text-sm text-left mt-1 md:mt-3 mx-auto pl-2 w-2/3 md:w-10/12">
                  <font-awesome-icon :icon="['far', 'check-square']" v-if="selectedGifts.indexOf(item.id) !== -1" class="text-xl md:text-base" />
                  <font-awesome-icon :icon="['far', 'square']" v-else  class="text-xl md:text-base" />
                  <span class="text-left leading-normal ml-1">{{ item.name }}</span>
                </div>
              </label>
            </swiper-slide>

          </swiper>
          <div class="swiper-button-next swiper-button-next-gift focus:outline-none cursor-pointer py-16 mt-0 hidden md:block" v-if="giftData.gift_options.length > 4"></div>
          <div class="swiper-button-prev swiper-button-prev-gift focus:outline-none cursor-pointer py-16 mt-0 hidden md:block" v-if="giftData.gift_options.length > 4"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sweetAlert from '@/components/modules/sweetAlert'

export default {
  name: 'CheckoutFreeGift',

  props: {
    giftData: {
      type: Object
    },
    hasSelectedItems: {
      type: Array
    }
  },
  mixins: [
    sweetAlert
  ],
  data () {
    return {
      renderComponent: true,
      selectedGifts: [],
      freeGiftOption: {
        direction: 'horizontal',
        slidesPerView: 4,
        spaceBetween: 5,
        loop: false,
        navigation: {
          enabled: false,
          nextEl: '.swiper-button-next-gift',
          prevEl: '.swiper-button-prev-gift'
        },
        breakpoints: {
          576: {
            direction: 'vertical',
            mousewheelControl: true,
            slidesPerView: 3,
            freeMode: true,
            freeModeSticky: true,
            navigation: {
              enabled: false
            }
          }
        }
      }
    }
  },
  watch: {
  },

  computed: {
    remainGiftSelect () {
      if (this.giftData.gift_options !== null) {
        return this.giftData.action_quantity - this.selectedGifts.length
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.selectedGifts = this.hasSelectedItems
  },
  methods: {
    selectItem (item) {
      let self = this
      if (!item.out_of_stock) {
        if (self.remainGiftSelect > 0 && self.selectedGifts.indexOf(item.id) === -1) {
          self.selectedGifts.push(item.id)
        } else if (self.selectedGifts.indexOf(item.id) !== -1) {
          self.selectedGifts.splice(self.selectedGifts.indexOf(item.id), 1)
        } else if (self.remainGiftSelect === 0 && self.selectedGifts.indexOf(item.id) === -1) {
          self.alertPop('warning', `贈品只能選擇 ${self.giftData.action_quantity} 件，若要更改，請先取消已勾選的贈品`)
        }
        self.emitItem()
      } else {
        self.$swal.fire({
          icon: 'info',
          title: 'Oops...',
          text: `${item.name} 已贈送完畢`,
          customClass: {
            confirmButton: 'bgLiveABCRed'
          }
        })
      }
    },
    emitItem () {
      let self = this
      let arr = {
        'id': self.giftData.id,
        'selected_gifts': self.selectedGifts
      }

      self.$emit('getSelectGift', arr)
    }
  }
}
</script>

<style lang="scss" scoped>
  .swiper-button-next-gift {
    right: -1.5rem;
    background-image: url('~@/assets/btn/arrow_circle_up.png');
    width: 40px !important;
    height: 100% !important;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background-size: 30px 30px !important;
    background-position: center;
    @media (min-width: 576px) {
      width: 5% !important;
    }
    @media (min-width: 1024px) {
      right: -2.5rem;
    }
  }
  .swiper-button-prev-gift {
    left: -1.5rem;
    background-image: url('~@/assets/btn/arrow_circle_down.png');
    width: 40px !important;
    height: 100% !important;
    transform: translateY(-50%);
    margin-top: 0 !important;
    background-size: 30px 30px !important;
    background-position: center;
    @media (min-width: 576px) {
      width: 5% !important;
    }
    @media (min-width: 1024px) {
      left: -2.5rem;
    }
  }
  .gift {
    .selectNumber {
        .arrow:after{
          display: block;
          content:'';
          border-width:8px 8px 8px 8px;
          border-style:solid;
          border-color:#EF0B0B transparent transparent transparent;

          /* 定位 */
          position:absolute;
          left: 30px;
          top:100%;
        }
        h5 {
          color: #434343;
          letter-spacing: .2rem;
        }
        .selectGift_bg {
          background-color: #EF0B0B;
        }
        .selectGift_color {
          color: #EF0B0B;
        }
      }
    .giftList {
      .gift-item {
        border: 0.5px solid #4B4B4B;
        .gift-inner {
          margin: 0 auto;
          position: relative;
          width: 60%;
          padding-bottom : 60%;
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          background-color: white;
          border: 0.5px solid #484848;
          .square-img {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 90%;
            padding-bottom : 90%;
            background-position: center center;
            background-repeat: no-repeat;
            background-size: contain;
          }
          .square-img-none {
            background-image: url('~@/assets/images/preset_item.png');
          }
        }
      }
      .selected {
        border: 0.5px solid #FDD8D8;
        background: #FDD8D8;
        height: 100%;
        .gift-inner {
          border: 0.5px solid #FDD8D8;
        }
      }

    }
  }
  .swiper_list {
    height: 330px !important;
    overflow-y: scroll;
    @media (min-width: 576px) {
      height: auto !important;
      overflow-y: auto;
    }
  }
</style>
